function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEducation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.149,
    y: 0.468,
    width: 44,
    height: 44,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.149,9.866C21.694,9.866 21.244,9.944 20.816,10.096L5.038,15.794C4.504,15.991 4.15,16.497 4.15,17.066C4.15,17.634 4.504,18.14 5.038,18.337L8.295,19.512C7.373,20.964 6.85,22.679 6.85,24.485L6.85,26.065C6.85,27.663 6.242,29.311 5.595,30.61C5.23,31.341 4.813,32.061 4.33,32.725C4.15,32.967 4.099,33.282 4.2,33.569C4.302,33.856 4.538,34.07 4.83,34.143L8.43,35.043C8.666,35.105 8.92,35.06 9.128,34.93C9.336,34.801 9.482,34.587 9.527,34.345C10.011,31.938 9.769,29.778 9.409,28.231C9.229,27.432 8.987,26.617 8.65,25.868L8.65,24.485C8.65,22.786 9.223,21.183 10.219,19.9C10.945,19.029 11.884,18.326 12.986,17.892L21.817,14.422C22.279,14.242 22.802,14.467 22.982,14.928C23.162,15.389 22.937,15.912 22.476,16.092L13.644,19.563C12.947,19.839 12.334,20.26 11.833,20.778L20.811,24.018C21.238,24.17 21.688,24.249 22.144,24.249C22.599,24.249 23.049,24.17 23.477,24.018L39.26,18.337C39.794,18.146 40.149,17.634 40.149,17.066C40.149,16.497 39.794,15.991 39.26,15.794L23.482,10.096C23.055,9.944 22.605,9.866 22.149,9.866ZM11.35,31.015C11.35,33.001 16.187,35.065 22.149,35.065C28.112,35.065 32.949,33.001 32.949,31.015L32.088,22.837L24.09,25.728C23.465,25.953 22.807,26.065 22.149,26.065C21.491,26.065 20.827,25.953 20.209,25.728L12.21,22.837L11.35,31.015Z",
    style: {
      fill: "#00659d",
      fillRule: "nonzero"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEducation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/education.632ec1e0b22098b1492d9176fe0afa41.svg";